/**
 * Created by Karan variya on 22/12/2018.
 */
export class DashModel {
    totaluser: number = 0;
    totaltodayregister: number = 0;
    totaltodayactive: number = 0;

    totalandroiddevice: number = 0;
    todayandroidregister: number = 0;
    todayandroidactive: number = 0;

    totaliosdevice: number = 0;
    todayiosregister: number = 0;
    todayiosactive: number = 0;

    totalhuaweidevice: number = 0;
    todayhuaweiregister: number = 0;
    todayhuaweiactive: number = 0;

    facebooklogin: number = 0;
    googlelogin: number = 0;
    huaweilogin: number = 0;
    applelogin: number = 0;
    normallogin: number = 0;
    emaillogin: number = 0;
    guestlogin: number = 0;

    totalactive: number = 0;
    totalcancel: number = 0;
    totalinactive: number = 0;

    // ios_subscription_ispremiumuser: number = 0;
    // ios_subscription_isprouser: number = 0;
    // ios_subscription_ispurchase: number = 0;
    // ios_subscription_isupgradetopro: number = 0;

    // androidactive: number = 0;
    // androidcancel: number = 0;
    // androidinactive: number = 0;

    // huaweiactive: number = 0;
    // huaweicancel: number = 0;
    // huaweiinactive: number = 0;
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/dashboard/DashModel.ts